import { useSelector } from "react-redux";
import Styles from '../Login.module.css';
import s2 from './VerifySecurityQuestion.module.css'
import { useState } from "react";
import {verifyAnswer} from '../../api/login'
import { useNavigate } from "react-router-dom";



const VerifySecurityQuestion = ()=>{
    const username = useSelector((state)=>state.auth.username);
    const question = useSelector((state)=>state.auth.securityQuestion);
    const [form,setForm]=useState({
        username:username,
        securityQuestionAnswer:''
    }); //保存用户名和答案

    const [error,setError] = useState('');

    const navigate = useNavigate();

    //监听input的输入，以及更新问题答案状态。
    const handleChange = (event) =>{
        const {name,value} = event.target;
        setForm({
            ...form,
            [name]:value
        })
    }

    //提交表单

    const handleSubmit = async (event)=>{
        event.preventDefault();
        const response = await verifyAnswer(form);

        try {
            if(response.data.code===200){
                alert('验证通过，请重置密码！');
                navigate('/login/resetPassword');
            }else{
                setError(response.data.message);
            }
            
        } catch (error) {
            setError( error.message || '网络请求失败，服务器可能未启动')
        }
    }


    return(
        <div>
            <form onSubmit={handleSubmit} className={Styles.common}>
                <input className={`${Styles.input} ${s2.inputBackgroundImageQuestion}`} readOnly='readOnly' placeholder={question} />
                <input  required='required' onChange={handleChange} name="securityQuestionAnswer" value={form.securityQuestionAnswer} style={{marginTop:'43.68px'}} className={`${Styles.input} ${s2.inputBackgroundImageAnswer}`} placeholder='Please Enter Your Answer.' />
                <button style={{marginTop:'43.68px'}} className={Styles.button}>SUBMIT</button>
                {error&&<p style={{color:'red'}}>{error}</p>}
            </form>
        </div>
    )
}

export default VerifySecurityQuestion;
